import React from "react"

import "./twoColumnRichContentBlock.scss"

const TwoColumnRichContentBlock = props => {
  return (
    <div className={`two_column_rich_content_block ${props.color_theme}`}>
      <div className="container">
        <div className="two_column_rich_content_wrapper">
          <div
            className="body-copy body-copy__left"
            dangerouslySetInnerHTML={{ __html: props.left_text }}
          ></div>
          <div
            className="body-copy body-copy__right"
            dangerouslySetInnerHTML={{ __html: props.right_text }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export default TwoColumnRichContentBlock
